/* eslint-disable import/no-unresolved */
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    useLazyQuery, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';

import { CREATE_FRY9C_USER_COMMENT, DELETE_FRY9C_USER_COMMENT, UPDATE_FRY9C_USER_COMMENT } from 'Apollo/Mutations/Rules/FRY9C';
import { GET_USER_INFO } from 'Apollo/Queries';
import { GET_COMMENTS_FOR_FRY9C } from 'Apollo/Queries/Rules/FRY9CResults';
import { tenantIdVar } from 'Apollo/config';
import FRY9CComment from '../components/FRY9CComment';

const FRY9CComments = ({ refetch }) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [fry9cComment, setFry9cComment] = useState('');
    const [fry9cShow, setFry9cShow] = useState(false);
    const [fry9cTarget, setFry9cTarget] = useState(null);
    const [fry9cEdit, setFry9cEdit] = useState(false);
    const [fry9cSelectedComment, setFry9cSelectedComment] = useState('');
    const [fry9cSelectedCommentID, setFry9cSelectedCommentID] = useState('');
    const [fry9cSelectedIndex, setFry9cSelectedIndex] = useState(null);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch user information  */
    const getFRY9CUser = useQuery(GET_USER_INFO);

    /* Apollo lazy query to fetch all the comments  */
    const [getComments, { loading, data: { getUserCommentsForFRY9C = {} } = {} }] = useLazyQuery(GET_COMMENTS_FOR_FRY9C, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add new comment  */
    const [addResultComment, { loading: commentLoading }] = useMutation(CREATE_FRY9C_USER_COMMENT, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
                commentText: fry9cComment,
            },
        },
    });

    /* Apollo mutation to delete a comment  */
    const [deleteComment] = useMutation(DELETE_FRY9C_USER_COMMENT);

    /* Apollo mutation to update comment  */
    const [updateComment] = useMutation(UPDATE_FRY9C_USER_COMMENT);

    /* Comment option handler */
    const handleFRY9CClick = (index, text, commentId, event) => {
        setFry9cShow(!fry9cShow);
        setFry9cSelectedIndex(index);
        setFry9cSelectedComment(text);
        setFry9cSelectedCommentID(commentId);
        setFry9cTarget(event.target);
    };

    /* Calls  addResultComment(), getComments() and refetch that failed tests result */
    const addFRY9CComment = async () => {
        await addResultComment();
        getComments();
        refetch();
        setFry9cComment('');
    };

    /* Toggled edit value */
    const onFRY9CEditClick = () => {
        setFry9cEdit(!fry9cEdit);
    };

    /* Cancal button handler */
    const onFRY9CCancelClick = () => {
        setFry9cEdit(!fry9cEdit);
        setFry9cSelectedIndex(null);
        setFry9cSelectedComment('');
        setFry9cShow(!fry9cShow);
    };

    /* Calls updateComment and refetch the failed tests resut */
    const onFRY9CClickSave = async () => {
        await updateComment({
            variables: {
                input: {
                    commentText: fry9cSelectedComment,
                    commentId: fry9cSelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setFry9cEdit(!fry9cEdit);
        setFry9cSelectedIndex(null);
        setFry9cSelectedComment('');
        setFry9cShow(!fry9cShow);
        refetch();
    };

    /* Calls deleteComment and refetch the failed tests resut */
    const onFRY9CClickDelete = async () => {
        await deleteComment({
            variables: {
                input: {
                    commentId: fry9cSelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setFry9cSelectedIndex(null);
        setFry9cSelectedComment('');
        setFry9cShow(!fry9cShow);
        refetch();
    };

    /* Side effect to fetch comments initially */
    useEffect(() => {
        getComments();
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <FRY9CComment
            getFRY9CUser={getFRY9CUser}
            fry9cComment={fry9cComment}
            setFRY9CComment={setFry9cComment}
            commentLoading={commentLoading}
            addFRY9CComment={addFRY9CComment}
            loading={loading}
            getUserCommentsForFRY9C={getUserCommentsForFRY9C}
            handleFRY9CClick={handleFRY9CClick}
            onFRY9CEditClick={onFRY9CEditClick}
            onFRY9CClickDelete={onFRY9CClickDelete}
            onFRY9CCancelClick={onFRY9CCancelClick}
            onFRY9CClickSave={onFRY9CClickSave}
            fry9cShow={fry9cShow}
            fry9cTarget={fry9cTarget}
            fry9cEdit={fry9cEdit}
            fry9cSelectedComment={fry9cSelectedComment}
            fry9cSelectedCommentID={fry9cSelectedCommentID}
            setFRY9CSelectedComment={setFry9cSelectedComment}
            fry9cSelectedIndex={fry9cSelectedIndex}
        />
    );
};

export default FRY9CComments;
